import styled from "styled-components/macro";

export const StatsElement = styled.div`
    height: 80px;
    text-transform: uppercase;
    color: #fff;
    width: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 15px;
    margin-left: 15px;

    .title {
        padding-top: 10px;
        font-size: 0.8em;
        flex: 1;
    }
`;
